import React, { Fragment, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import CloseIcon from '@mui/icons-material/Close';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import utils from 'components/utils';

const RequestApproveButton = props => {
	const { item } = props;
	const theme = useTheme();
	const translate = utils.useI18N();
	const loadingUpdate = useStoreState(state => state.wishlistSpecial.loadingUpdate);
	const requestApprove = useStoreActions(dispatch => dispatch.wishlist.list.requestApprove);
	const [open, setOpen] = useState(false);

	const handleClose = () => {
		setOpen(false);
	};

	const handleApprove = _ => {
		requestApprove(item.id);
		setOpen(false);
	};

	return (
		<Fragment>
			<Button variant="dark" onClick={_ => setOpen(true)}>
				{translate('wishlistSpecial.requestApprove')}
			</Button>
			<Dialog open={open} onClose={handleClose} aria-labelledby="responsive-dialog-title">
				<DialogTitle id="responsive-dialog-title" sx={{ marginBottom: '-10px !important' }}>
					{translate('wishlistSpecial.requestApprove')}
				</DialogTitle>
				<DialogContent>
					<Stack
						direction="column"
						justifyContent="flex-start"
						alignItems="flex-start"
						spacing={1}
						sx={{
							width: '100%',
							borderWidth: '1px 0 0 0',
							borderStyle: 'solid',
							borderColor: theme.palette.primary.main,
							paddingTop: '15px !important'
						}}
					>
						<Typography variant="text" sx={{ fontWeight: '600' }}>
							{translate('wishlistSpecial.wishlistSpecial') + ': ' + item.name}
						</Typography>
						<Typography variant="text">{translate('wishlistSpecial.requestApproveDesc')}</Typography>
					</Stack>
				</DialogContent>
				<DialogActions>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
						spacing={0}
						sx={{ width: '100%' }}
					>
						<Button variant="light" onClick={handleClose} endIcon={<CloseIcon />}>
							{translate('common.cancel')}
						</Button>
						<LoadingButton
							variant="dark"
							onClick={handleApprove}
							endIcon={<ThumbUpOffAltIcon />}
							loading={loadingUpdate}
							loadingPosition="end"
						>
							{translate('common.confirm')}
						</LoadingButton>
					</Stack>
				</DialogActions>
			</Dialog>
		</Fragment>
	);
};

export default RequestApproveButton;
